interface ICheckMarkIconProps {
  className?: string;
}

/**
 * -----------------------------------------------------------------------------
 * It renders a green tick mark icon which uses in b2b home page.
 */
export function CheckMarkIcon({ className }: Readonly<ICheckMarkIconProps>) {
  return (
    <svg className={className} fill="none" viewBox="0 0 16 17">
      <path
        d="M13.333 5.232 6 12.565 2.667 9.232"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
    </svg>
  );
}
